
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29 25.1c-1.5 2.1-3.3 3.8-5.6 5-2.3 1.3-4.9 1.9-7.5 1.9s-5.2-.6-7.5-1.9c-2.3-1.2-4.2-2.9-5.6-5C1.3 23 .4 20.6 0 18h4c.3 1.9 1.1 3.6 2.2 5.1 1.1 1.5 2.5 2.7 4.2 3.6 1.8.9 3.6 1.3 5.6 1.3 2.1 0 4.1-.5 5.9-1.6 1.8-1 3.2-2.4 4.3-4.2L21.9 18h10v10L29 25.1zM16.1 4c-2.1 0-4.1.5-5.9 1.6-1.9 1-3.3 2.4-4.3 4.2l4.2 4.2H0V4l3 2.9c1.5-2.1 3.3-3.8 5.6-5C10.9.6 13.4 0 16.1 0s5.2.6 7.5 1.9c2.3 1.2 4.1 2.9 5.6 5s2.4 4.5 2.8 7.1h-4c-.3-1.9-1.1-3.6-2.2-5.1s-2.5-2.7-4.2-3.6C19.8 4.4 18 4 16.1 4z"}})])
          )
        }
      }
    